/**
 * Timezone constants for YOYO Club
 *
 * Currently all activities are in the Bay Area (America/Los_Angeles).
 * In the future, if we support multiple timezones, each activity
 * can have its own timezone field.
 */

export const DEFAULT_TIMEZONE = 'America/Los_Angeles';

/**
 * Get the timezone for an activity
 * Currently returns the default timezone, but can be extended
 * to support per-activity timezone in the future.
 */
export const getActivityTimezone = (_activity?: { timezone?: string }): string => {
  // Future: return activity?.timezone || DEFAULT_TIMEZONE;
  return DEFAULT_TIMEZONE;
};
